<template>
  <div>
    <div
      style="
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <img v-if="currentItem" class="current-style" :src="currentItem.url" />
      <div
        v-if="currentItem.isUsing"
        style="position: absolute"
        :style="{
          width: $px2rem(`${506}px`),
          top: $px2rem(`${20}px`),
        }"
      >
        <img
          src="@/assets/haveing-icon.png"
          style="position: absolute; top: 0; right: 0"
          :style="{
            width: $px2rem(`${95}px`),
            height: $px2rem(`${101}px`),
          }"
        />
      </div>
    </div>
    <div class="select-label">风格选择</div>
    <div class="st-box">
      <div
        class="st-item"
        v-for="(item, index) in styleList"
        :key="index"
        :style="{
          background: item.isUsing ? '#F0B75D' : 'transparent',
        }"
      >
        <div
          class="st-items"
          @mouseenter="mouseover(index)"
          @mouseleave="mouseout(index)"
        >
          <div style="position: relative">
            <img :src="item.url" class="st-item-bg" alt="" />
            <img
              v-if="item.isHave && item.price > 0"
              style="position: absolute; top: 0; right: 0"
              :style="{
                width: $px2rem(`${114}px`),
                height: $px2rem(`${84}px`),
              }"
              src="@/assets/status-icon.png"
            />
          </div>
          <div
            v-if="currentIndex === index && isCover"
            class="cover-text"
            @click="coverImg(item)"
          >
            预览
          </div>
          <div
            v-if="currentIndex === index && isCover"
            class="cover-text"
            @click="coverImg(item)"
          >
            预览
          </div>
          <div
            :style="{
              'padding-left': $px2rem(`${20}px`),
              'padding-right': $px2rem(`${20}px`),
            }"
          >
            <div class="st-item-title">{{ item.name }}</div>
            <div class="st-item-price" v-if="item.isHave">
              <span
                style="color: #575757; font-weight: 400"
                :style="{
                  'font-size': $px2rem(`${14}px`),
                }"
                >终身有效</span
              >
            </div>
            <div class="st-item-price" v-else-if="item.price == 0">免费</div>
            <div class="st-item-price" v-else>
              {{ "￥" + item.price }}
              <span
                style="color: #575757; font-weight: 400"
                :style="{
                  'font-size': $px2rem(`${14}px`),
                }"
                >/终身</span
              >
            </div>

            <div
              :class="[item.isUsing ? 'inUse' : 'useNow']"
              @click.stop="checkUsed(item)"
            >
              {{ item.isUsing ? "在使用" : "立即使用" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zhezhao2" v-show="showPayDia" @click="showPayDia = false"></div>

    <transition  name="el-zoom-in-center">
      <div
        v-show="showPayDia"
        style="
          width: 450px;
          padding-bottom: 50px;
          box-sizing: border-box;
          z-index: 201;
          top: 20%;
          position: fixed;
          left: 0;
          right: 0;
          margin: 0 auto;
          border-radius: 14px;
          background: linear-gradient(180deg, #ffffff 42%, #fff4ef 100%);
        "
      >
        <div
          style="
            width: 450px;
            height: 49px;
            background: #583725;
            border-radius: 14px 14px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <div
            style="
              font-size: 20px;
              color: #ffffff;
              font-weight: 600;
              line-height: 28px;
              letter-spacing: 0.04em;
              text-align: center;
            "
          >
            场馆支付
          </div>
          <div
            style="position: absolute; top: 10px; right: 20px"
            @click="closeOrder"
          >
            <img
              src="@/assets/pay_close.png"
              style="width: 13px; height: 13px"
            />
          </div>
        </div>

        <div v-show="orderCreate.step === 1">
          <div
            v-for="(item, index) in zhifuList"
            :key="index"
            style="margin-top: 30px"
          >
            <div
              style="
                width: 345px;
                height: 100px;
                border-radius: 10px;
                border: 2px solid #ffcb7ead;
                margin: 0 auto;
                background: #fff6e9;
                display: flex;
                align-items: center;
                justify-content: space-around;
              "
              :style="{
                'margin-bottom':
                  index + 1 !== zhifuList.length ? '30px' : '0px',
              }"
              @click="changeZhifuTap(item)"
            >
              <div style="display: flex">
                <img :src="item.url" style="width: 40px; height: 40px" />
                <div style="margin-left: 5px">
                  <div
                    style="
                      font-size: 16px;
                      font-weight: 400;
                      line-height: 22.4px;
                      text-align: left;
                      color: #575757;
                    "
                  >
                    {{ item.name }}支付
                  </div>
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 400;
                      line-height: 16.8px;
                      text-align: left;
                      color: #8a8a8a;
                    "
                  >
                    使用{{ item.name }}扫码支付
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="@/assets/radio_true.png"
                  style="width: 30px; height: 30px"
                  v-if="item.check"
                />
                <img
                  src="@/assets/radio_false.png"
                  style="width: 30px; height: 30px"
                  v-else
                />
              </div>
            </div>
          </div>
          <!-- <div
            style="
              width: 345px;
              height: 100px;
              border-radius: 10px;
              border: 2px solid #ffcb7ead;
              margin: 50px auto 0 auto;
              background: #fff6e9;
              display: flex;
              align-items: center;
              justify-content: space-around;
            "
            @click="orderCreate.paymentType = 3"
          >
            <div style="display: flex">
              <img
                src="@/assets/wechat.png"
                style="width: 40px; height: 40px"
              />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  微信支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用微信扫码支付
                </div>
              </div>
            </div>
            <div>
              <img
                src="@/assets/radio_true.png"
                style="width: 30px; height: 30px"
                v-if="orderCreate.paymentType === 3"
              />
              <img
                src="@/assets/radio_false.png"
                style="width: 30px; height: 30px"
                v-else
              />
            </div>
          </div> -->
          <!-- <div  style="
              width: 345px;
              height: 70px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: space-around;"></div> -->

          <!-- <div
            style="
              width: 345px;
              height: 100px;
              border-radius: 10px;
              border: 2px solid #ffcb7ead;
              margin: 0 auto;
              margin-top: 10px;
              background: #fff6e9;
              display: flex;
              align-items: center;
              justify-content: space-around;
            "
            @click="orderCreate.paymentType = 1"
          >
            <div style="display: flex">
              <img src="@/assets/ali.png" style="width: 40px; height: 40px" />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  支付宝支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用支付宝扫码支付
                </div>
              </div>
            </div>
            <div>
              <img
                src="@/assets/radio_true.png"
                style="width: 30px; height: 30px"
                v-if="orderCreate.paymentType === 1"
              />
              <img
                src="@/assets/radio_false.png"
                style="width: 30px; height: 30px"
                v-else
              />
            </div>
          </div> -->
          <div
            style="
              width: 190px;
              height: 48px;
              background-color: #4a2a19;
              border-radius: 8px;
              margin: 0 auto;
              margin-top: 30px;
              align-items: center;
              display: flex;
              justify-content: center;
            "
            @click="orderPre"
          >
            <div
              style="
                font-size: 16px;
                font-weight: 400;
                line-height: 22.4px;
                color: #ffffff;
                text-align: center;
              "
            >
              确定
            </div>
          </div>
        </div>

        <div v-show="orderCreate.step === 2">
          <div
            style="margin-top: 20px; display: flex; justify-content: left"
            @click="orderPreStep"
          >
            <img
              src="@/assets/left-icon.png"
              style="width: 12px; height: 21px; margin-left: 22px"
            />
            <div
              style="
                font-size: 20px;
                font-weight: 400;
                line-height: 26px;
                text-align: center;
                color: #b6b6b6;
                margin-left: 14px;
              "
            >
              返回
            </div>
          </div>
          <div
            style="
              margin-top: 15px;
              align-items: center;
              display: flex;
              justify-content: center;
            "
          >
            <div style="display: flex" v-if="orderCreate.paymentType === 3">
              <img
                src="@/assets/wechat.png"
                style="width: 40px; height: 40px"
              />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  微信支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用微信扫码支付
                </div>
              </div>
            </div>
            <div style="display: flex" v-if="orderCreate.paymentType === 1">
              <img src="@/assets/ali.png" style="width: 40px; height: 40px" />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  支付宝支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用支付宝扫码支付
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              width: 198px;
              height: 210px;
              border: 1px solid #e9e9e9;
              margin: 0 auto;
              margin-top: 22px;
            "
          >
            <div v-if="orderCreate.paymentType === 3" style="margin-top: 10px">
              <vue-qr
                style="width: 142px; height: 147px"
                :text="orderCreate.outBody"
              ></vue-qr>
            </div>
            <div
              v-if="orderCreate.paymentType === 1"
              style="
                width: 142px;
                height: 142px;
                margin: 0 auto;
                margin-top: 10px;
              "
            >
              <iframe
                :srcdoc="orderCreate.outBody"
                frameborder="no"
                border="0"
                marginwidth="0"
                marginheight="0"
                scrolling="no"
                width="142"
                height="142"
                style="overflow: hidden"
              >
              </iframe>
            </div>
            <div
              style="
                font-size: 12px;
                font-weight: 400;
                line-height: 16.8px;
                color: #575757;
                word-wrap: break-word;
                width: 106px;
                margin: 0 auto;
                margin-top: 10px;
                text-align: center;
              "
            >
              <div>
                打开手机端{{
                  orderCreate.paymentType === 1 ? "支付宝" : "微信"
                }}
              </div>
              <div>扫一扫继续付款</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {
  orderPre,
  orderQueryStatus,
  styleList,
  styleSet,
  getDictTypeDate,
} from "@/api/request";
import { Base64 } from "js-base64";
import vueQr from "vue-qr";
export default {
  components: { vueQr },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      styleList: [],
      currentIndex: 0,
      isCover: false,
      currentItem: {},
      currentStyle: "",
      orderCreate: {
        step: 1,
        paymentType: 3,
        tradeNo: null,
        outBody: "",
      },
      showPayDia: false,
      zhifuList: [],
    };
  },
  created() {
    this.orderCreate.refId = this.id;
    this.styleLists();
    this.getZfList();
  },
  methods: {
    changeZhifuTap(e) {
      e.check = !e.check;
      this.orderCreate.paymentType = e.paymentType;
      this.zhifuList.forEach((t) => {
        if (t.name != e.name) {
          t.check = false;
        }
      });
    },
    getZfList() {
      getDictTypeDate("zfkey").then((r) => {
        let a = {
          name: "支付宝",
          paymentType: 1,
          check: false,
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/ali.png",
        };
        let b = {
          name: "微信",
          paymentType: 3,
          check: false,
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/wechat.png",
        };
        r.data.data.map((e) => {
          if (e.dictValue == a.paymentType && e.status == 0) {
            this.zhifuList.push(a);
          }
          if (e.dictValue == b.paymentType && e.status == 0) {
            this.zhifuList.push(b);
          }
        });
      });
    },
    styleLists() {
      styleList({
        pageNum: 1,
        pageSize: 1000,
        hallId: this.id,
      }).then((res) => {
        this.styleList = res.data.rows;
        this.currentItem = this.styleList.filter((item) => item.isUsing)[0];
        // this.currentStyle = this.styleList.filter(item => item.isUsing)[0].url
      });
    },
    mouseover(index) {
      this.currentIndex = index;
      this.isCover = true;
    },
    mouseout(index) {
      this.currentIndex = index;
      this.isCover = false;
    },
    coverImg(item) {
      this.currentItem = item;
      this.currentStyle = item.url;
    },
    checkUsed(e) {
      if (e.isUsing) {
        return;
      }
      let data = {
        hallId: this.id,
        styleId: e.id,
      };
      //TODO 权限判断
      if (e.isHave || e.price === 0) {
        styleSet(data).then((r) => {
          if (!r || r.code !== 200) {
            return;
          }
          e.isUsing = !e.isUsing;
          this.styleList.map((item, index) => {
            if (item.id !== e.id) {
              item.isUsing = false;
            }
          });
          this.styleLists();
        });
      } else {
        this.orderCreate.items = [
          {
            itemCount: 1,
            itemId: e.id,
            itemType: 2,
          },
        ];
        this.showPayDia = true;
      }
    },
    orderPre() {
      let ifCheck = this.zhifuList.filter((item) => {
        return item.check == true;
      });
      if (ifCheck.length == 0) {
        this.orderCreate.paymentType = null;
        this.$message({
          showClose: true,
          message: "请选择一种支付方式！",
          type: "error",
        });
        return;
      }
      orderPre(this.orderCreate).then((r) => {
        if (r.data.code !== 200) {
          this.$message.error(r.data.msg);
        } else {
          this.orderCreate.step = 2;
          this.orderCreate.tradeNo = r.data.data.orderNo;
          if (this.orderCreate.paymentType === 3) {
            this.orderCreate.outBody = r.data.data.outBody;
          } else {
            this.orderCreate.outBody = Base64.decode(r.data.data.outBody);
          }
          this.clearTimer();
          this.orderQueryTimer = setInterval(() => {
            this.orderQueryStatus(this.orderCreate.tradeNo);
          }, 1000);
        }
      });
    },
    orderQueryStatus(code) {
      if (!code) {
        return;
      }
      orderQueryStatus(code).then((r) => {
        if (r.data.data === 4) {
          this.$message.success("支付成功");
          if (this.orderCreate.items[0].itemType === 2) {
            this.styleList = [];
            this.styleLists();
          }
          this.closeOrder();
        } else if (r.data.data === 3 || r.data.data === 5) {
          this.$message.error("订单失效，请刷新页面重新支付");
          this.closeOrder();
        }
      });
    },
    closeOrder() {
      this.showPayDia = false;
      this.orderCreate.step = 1;
      this.orderCreate.items = [];
      this.orderCreate.tradeNo = null;
      this.clearTimer();
    },
    orderPreStep() {
      this.orderCreate.step = 1;
      this.clearTimer();
    },
    clearTimer() {
      if (this.orderQueryTimer) {
        clearInterval(this.orderQueryTimer);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./main.scss";

:deep .el-dialog {
  border-radius: 14px;
}
:deep .el-dialog__header {
  background: #583725;
  border-radius: 11px 11px 0 0;
}
:deep .el-dialog__title {
  font-size: 20px;
  color: #ffffff;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0.04em;
}
:deep .el-icon-close {
  color: #ffffff;
  font-size: 20px;
}
.current-style {
  width: 506px;
  height: 285px;
  border-radius: 10px;
  margin: 20px 0;
}
.select-label {
  font-size: 16px;
  color: #575757;
  font-weight: 600;
  margin: 18px 0;
  text-align: left;
}
.zhezhao2 {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .5;
  background: #000;
  z-index: 200;
}

</style>
